import { Component, ChangeEvent, Suspense } from 'react'
import { connect } from 'react-redux'
import { sortList, getNominative } from '../../../common/utils'
import PopupModal from '../../modals/PopupModal'
import Field from '../../fields'
import { ResidentSelectOption } from '../../generic'

interface ZoneFormProps {
  formId: string
  residents: any[]
  isEdit: boolean
  onSubmit: () => void
  preferredPeopleNominative: string
  setFormField?: (field: { key: string; value: any }) => void
}

interface ZoneFormState {
  selectedResidents: string
}

class ZoneForm extends Component<ZoneFormProps, ZoneFormState> {
  constructor(props: ZoneFormProps) {
    super(props)
    this.state = {
      selectedResidents: ''
    }
  }

  handleResidentsChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const selection = event.target.value
    this.setState({ selectedResidents: selection })
    this.props.setFormField?.({
      key: 'residents',
      value: selection.split(',').filter((entry) => entry !== '')
    })
  }

  render() {
    const {
      formId,
      isEdit,
      onSubmit,
      residents,
      preferredPeopleNominative,
      ...formProps
    } = this.props

    return (
      <PopupModal
        confirmText={isEdit ? 'Save' : 'Add'}
        buttonIcon={isEdit ? 'CheckOutlined' : 'PlusOutlined'}
        buttonColour="success"
        list="Zone"
        includesRequired
        onConfirm={onSubmit}
        style={{ overflowY: 'inherit' }}
        type={isEdit ? 'edit' : 'create'}
        {...formProps}
      >
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={formId}
            keys="name"
            label="Title"
            required
            // @ts-ignore
            values={formProps.fields}
            type="text"
          />
        </Suspense>
        <div style={{ paddingTop: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formatOptionLabel={ResidentSelectOption}
              formId={formId}
              keys="residents"
              label={getNominative(preferredPeopleNominative, 'Residents')}
              options={sortList(residents, ({ status }) =>
                ['active', 'dummy'].includes(status)
              )}
              required
              type="multiSelect"
              // @ts-ignore
              values={formProps.fields}
              onChange={this.handleResidentsChange}
              value={this.state.selectedResidents}
            />
          </Suspense>
        </div>
      </PopupModal>
    )
  }
}

const mapStateToProps = (state: any) => {
  return {
    residents: state.data.residents,
    preferredPeopleNominative: state.global.home.preferredPeopleNominative
  }
}

export default connect(mapStateToProps, null)(ZoneForm)
